import { createApiReducers, createApiReducerInitialState } from '../../../Helpers/reducer'
import { CONTACT_EXPORT } from './constants'

const NAMESPACE = 'singleContactExport'

const initialState = createApiReducerInitialState(NAMESPACE, {})
const reducers = createApiReducers(CONTACT_EXPORT, NAMESPACE, {})

export default (state = initialState, action) => (reducers[action.type] ? reducers[action.type](state, action) : state)
